module.exports = __webpack_public_path__ + "media/images/oficinas/virasoro-5b190954e3cedce945abe1f1ea0664c8.jpg";